import { Pipe, PipeTransform } from '@angular/core';
import { ViewAccessDto } from 'src/app/core/services/view-access-api.service';
import { SideNavItem } from 'src/app/shell/side-navigation/side-nav/side-nav-item.model';

@Pipe({ name: 'menuItemsFilter' })
export class MenuItemsFilterPipe implements PipeTransform {
  transform(menuItems: SideNavItem[], viewAccess: ViewAccessDto[]): SideNavItem[] {
    if (!Array.isArray(viewAccess)) {
      return menuItems;
    }

    const viewNames = viewAccess.reduce(this.#viewNameReducer, []);
    return menuItems.reduce(this.#menuItemsReducer(viewNames), []);
  }

  readonly #viewNameReducer = (accumulator, current) => {
    if (current.subViews) {
      const withSubviews = current.subViews.reduce(this.#viewNameReducer, []);
      return accumulator.concat(withSubviews);
    } else {
      accumulator.push(current.viewName);
    }
    return accumulator;
  };

  readonly #menuItemsReducer = viewNames => {
    const reducer = (accumulator, current) => {
      if (current.children) {
        const children = current.children.reduce(reducer, []);
        if (children.length > 0 || viewNames.includes(current.viewName)) {
          current.children = children;
          accumulator.push(current);
        }
      } else {
        if (viewNames.includes(current.viewName)) {
          accumulator.push(current);
        }
      }
      return accumulator;
    };

    return reducer;
  };
}
